<div [ngClass]="{'centered' : !inline}">
  <div class="spinner-box" [style.width.px]="size" [style.height.px]="size">
    <div class="floatingCirclesG" [style.transform]="'scale(' + scale + ')'">
      <div class="f_circleG frotateG_01"></div>
      <div class="f_circleG frotateG_02"></div>
      <div class="f_circleG frotateG_03"></div>
      <div class="f_circleG frotateG_04"></div>
      <div class="f_circleG frotateG_05"></div>
      <div class="f_circleG frotateG_06"></div>
      <div class="f_circleG frotateG_07"></div>
      <div class="f_circleG frotateG_08"></div>
    </div>
  </div>
</div>
